import { render, staticRenderFns } from "./PublicQuotationPages6.vue?vue&type=template&id=032437ac&scoped=true&"
import script from "./PublicQuotationPages6.vue?vue&type=script&lang=js&"
export * from "./PublicQuotationPages6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032437ac",
  null
  
)

export default component.exports